import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ errorInfo });
  }

  handleRefresh = () => window.location.reload();
  handleGoHome = () => window.location.href = '/dashboard';

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-surface-50 dark:bg-surface-950 flex items-center justify-center p-4">
          <div className="max-w-md w-full">
            <div className="text-center">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-danger-100 dark:bg-danger-900/30 flex items-center justify-center">
                <AlertTriangle className="w-10 h-10 text-danger-600 dark:text-danger-400" />
              </div>
              <h1 className="text-2xl font-bold text-surface-900 dark:text-white mb-2">
                Something Went Wrong
              </h1>
              <p className="text-surface-500 dark:text-surface-400 mb-6">
                {this.state.error?.message || 'An unexpected error occurred'}
              </p>
              <div className="flex gap-3 justify-center">
                <button
                  onClick={this.handleRefresh}
                  className="btn btn-primary"
                >
                  <RefreshCw className="w-4 h-4" />
                  Refresh
                </button>
                <button
                  onClick={this.handleGoHome}
                  className="btn btn-secondary"
                >
                  <Home className="w-4 h-4" />
                  Go Home
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;